// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"Index_modal-scroll__AdqoK","contentsArea":"Index_contentsArea__T_qlg","contentsWrap":"Index_contentsWrap__awUEU"};